/**
 * Split an array into chunks of three from right to left.
 * @param {array} input
 */
function chunk3Array(input) {
  const r = input.length % 3;
  let out = [];
  if (r > 0) {
    out.push(input.slice(0, r));
  }
  const rest = input.slice(r);
  for (let i = 0; i < rest.length; i += 3) {
    let chunk = rest.slice(i, i + 3);
    out.push(chunk);
  }
  return out;
}

/**
 * Add a dollar sign and thousands commas to a string.
 *
 * @param {string} input
 */
export default function formatCurrency(input) {
  const re = /\d/;
  const digitArray = input.split("").filter(x => x.match(re));
  if (!digitArray.length) {
    return "";
  }
  const chunked = chunk3Array(digitArray);
  const formatted = chunked.map(x => x.join("")).join(",");
  return `$${formatted}`;
}
